<div class="c-wrapper">
    <div class="c-n-wrapper">
        <span multilang class="ratting">
            <mat-icon class="rico" *ngFor="let cat of categoryAr;">{{cat === 1 ? 'star':
                'star_half'}}</mat-icon>
        </span>
        <div class="topw">
            <span multilang class="c-title">{{hotel?.name}}</span>
            <ng-container *ngIf="hotel?.rating?.recommendation > 0">
                <div class="purswr">
                    <mat-icon class="pursico">thumb_up_alt</mat-icon>
                    <span multilang class="purct">{{hotel?.rating?.recommendation}}%</span>
                </div>
            </ng-container>
        </div>

        <div class="dg-info-item mt">
            <span multilang [class.dg-info-item-first]="deskMode"
                [class.dg-info-item-first-mobile]="!deskMode">Reisezeitraum:</span>
            <span multilang>{{datas?.filter?.checkin | date:'dd.MM.yyyy'}} -
                {{datas?.filter?.checkout | date:'dd.MM.yyyy'}}</span>
        </div>
        <div class="dg-info-item">
            <span multilang [class.dg-info-item-first]="deskMode"
                [class.dg-info-item-first-mobile]="!deskMode">Dauer:</span>
            <span multilang>{{dauer()}} {{dauer() === '1' ?
                'Nacht' : 'Nächte'}}</span>
        </div>
        <div class="dg-info-item">
            <span multilang [class.dg-info-item-first]="deskMode"
                [class.dg-info-item-first-mobile]="!deskMode">Zimmer:</span>
            <span multilang>{{datas?.filter?.guests?.length}} x
                {{datas?.prc?.room_name}}</span>
        </div>
        <div class="dg-info-item"
            [style.color]="datas?.prc?.meal?.indexOf('breakfast') >= 0 || datas?.prc?.meal?.indexOf('half-board') >= 0 ? '#008900': ''">
            @if(datas?.prc?.meal === 'nomeal') {
            <span multilang class="cc21">Keine Mahlzeiten</span>
            } @else if(datas?.prc?.meal?.indexOf('breakfast') >= 0){
            <span multilang class="cc21">Frühstück inbegriffen</span>
            } @else if(datas?.prc?.meal?.indexOf('half-board') >= 0){
            <span multilang style="width: calc(100% - 30px);word-break: break-all;">Frühstück und Abendessen
            </span>
            }
        </div>

        <div class="dg-info-item"
            [style.color]="datas?.prc?.cancellation_penalties?.free_cancellation_before?.length > 0? '#008900': ''">
            @if(datas?.prc?.cancellation_penalties?.free_cancellation_before?.length
            > 0) {
            <span multilang class="cc21">Kostenlose Stornierung</span>
            } @else {
            <span multilang class="cc21">Kein Gratis-Storno</span>
            }
        </div>
    </div>

    <div class="c-block">
        <div class="c-item">
            <span multilang class="c-item-title">Preis</span>
            <div class="offerprice">
                <span multilang class="f400">
                    <span multilang>Erwachsene : {{adults()}}</span>
                    @if(child() > 0) {
                    <span multilang style="margin-left: .5rem;">Kinder :
                        {{child()}}</span>
                    }
                </span>
                <span multilang multilang deeplMode='html' [innerHtml]="prcdetail | safehtml"></span>
                <div class="offerpriceTotal">
                    <span multilang>Gesamtpreis:</span>
                    <span multilang class="prccolor">{{datas?.prc?.payment_options?.payment_types?.[0]?.show_amount
                        |
                        number:'1.2-2'}}
                        {{datas?.prc?.payment_options?.payment_types?.[0]?.show_currency_code}}</span>
                </div>
            </div>
        </div>
    </div>

    <div class="c-block">
        @if(images?.length > 0) {
        <div class="c-item">
            <span multilang class="c-item-title">Bilder</span>
            <div class="imgw">
                <ng-container *ngFor="let im of images;let k=index">
                    <img *ngIf="im?.length > 0" (click)="openImageModal(k)" src="{{im | cacheResource}}"
                        class="lazyload myimg">
                </ng-container>
            </div>
        </div>
        }
    </div>

    <div class="c-block">
        <div class="c-item">
            <span multilang class="c-item-title">Hotelinformationen</span>
            @for (item of hotel.description_struct; track $index) {
            <div class="vorteile">
                <span multilang class="cc22title">{{item.title}}</span>
                @for (pr of item.paragraphs; track $index) {
                <span multilang>{{pr}}</span>
                }
            </div>
            }
        </div>
        <div class="c-item">
            <span multilang class="c-item-title">Fakten zum Hotel</span>
            @if(hotel.facts?.year_built) {
            <div class="cc23">
                <span multilang class="cc23title">Baujahr</span>
                <span multilang>{{hotel.facts.year_built}}</span>
            </div>
            }
            @if(hotel.facts?.year_renovated) {
            <div class="cc23">
                <span multilang class="cc23title">Renovierungsjahr</span>
                <span multilang>{{hotel.facts.year_renovated}}</span>
            </div>
            }
            @if(hotel.facts?.electricity) {
            <div class="cc23">
                <span multilang class="cc23title">Steckdosentyp</span>
                <span multilang>{{hotel.facts.electricity.sockets?.join(',')}}</span>
                <span multilang>{{hotel.facts.electricity.voltage?.[0]}} Volt /
                    {{hotel.facts.electricity.frequency?.[0]}}
                    Hz</span>
            </div>
            }
            @if(hotel.facts?.rooms_number && hotel.facts?.floors_number) {
            <div class="cc23">
                <span multilang class="cc23title">Zimmer- und Etagennummern</span>
                <span multilang>{{hotel.facts.rooms_number}} Zimmer • {{hotel.facts?.floors_number}} Etagen</span>
            </div>
            }
        </div>
        <div class="c-item">
            <span multilang class="c-item-title">An- und Abreise</span>
            <div class="cc23">
                <span multilang class="cc23title">Anreise</span>
                <span multilang>Nache {{hotel.check_in_time}}</span>
            </div>
            <div class="cc23">
                <span multilang class="cc23title">Abreise</span>
                <span multilang>Bis {{hotel.check_out_time}}</span>
            </div>
        </div>
        <div class="c-item">
            <span multilang class="c-item-title">Welche anderen Ausstattungsangebote gibt es?</span>
            <div class="cc24">
                @for (item of hotel.amenity_groups; track $index) {
                <div class="cc22">
                    <span multilang class="cc22title">{{item.group_name}}</span>
                    @for (pr of item.amenities; track $index) {
                    <span multilang class="cc22text">- {{pr}}
                        <br>
                        @if(item.non_free_amenities?.indexOf(pr)>= 0) {
                        <span multilang class="cc22sepb">separat berechnet</span>
                        }
                    </span>
                    }
                </div>
                }
            </div>
        </div>

        @if(hotel?.policy_struct?.length > 0) {
        <div class="c-item">
            <span multilang class="c-item-title">Vor Ort gezahlt</span>
            @for (item of hotel.policy_struct; track $index) {
            <div class="cc22">
                <span multilang class="cc22title">{{item.title}}</span>
                @for (pr of item.paragraphs; track $index) {
                <span multilang class="cc22text" multilang deeplMode='html' [innerHtml]="pr"></span>
                }
            </div>
            }
        </div>
        }

        <div class="c-block">
            <ng-container *ngIf="hotel?.latitude > 0">
                <div class="c-item">
                    <span multilang class="c-item-title">Lage</span>
                    <ng-container *ngTemplateOutlet="lage"></ng-container>
                </div>
            </ng-container>
        </div>

        <div class="f-btn-wrapper">
            <button class="f-btn colorB" matRipple (click)="sendBooking()">Jetzt buchen</button>
            <button class="f-btn colorA" matRipple (click)="sendAalternative()">Alternative</button>
        </div>
    </div>


    <div class="fixedlefttop">
        <button class="f-btn colorA" matRipple (click)="sendAalternative()">Alternative</button>
        <button class="f-b-top" matRipple (click)="sendBooking()">Jetzt buchen</button>
    </div>

    <ng-template #lage>
        <div class="mymap">
            <div id="map" class="mapw"></div>
        </div>
    </ng-template>